/**
 * Validate a string as a phone number
 */
export function isValidPhoneNumber(phoneNumber: string) {
  return /^[\+]?[(]?[0-9]{1}[)]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(
    phoneNumber
  )
}

/**
 * Format 10-digit phone numbers. A more full-featured solution will be necessary
 *   if we want to support international phone numbers.
 */
export function formatPhoneNumber(phoneNumber: string) {
  if (phoneNumber.length === 10) {
    return `(${phoneNumber.substr(0, 3)}) ${phoneNumber.substr(3, 3)}-${phoneNumber.substr(6)}`
  }

  return phoneNumber
}
